/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Container, Row, Col, Card, Collapse, Button } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import { useEffect, useState } from "react"
import DateInput from "../../../components/InputWrapper/DateInput"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import TextInput from "../../../components/InputWrapper/TextInput"
import UnsogyomuHatyusyoGrid from "../UnsogyomuHatyusyo/UnsogyomuHatyusyoGrid"
import { Form } from "react-bootstrap"
import Spinner from "../../../components/Spinner"
import { UnsogyomuHatyusyoProvider } from "../UnsogyomuHatyusyo/UnsogyomuHatyusyoContext"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import queryString from "query-string"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import {
  TUnsogyomuHatyusyoGetReq,
  TUnsogyomuHatyusyoGetReqInner,
  T運送業務発注書印刷,
} from "../../../service/order/unsogyomuHatyusyo/TUnsogyomuHatyusyo"
import UnsogyomuHatyusyoService from "../../../service/order/unsogyomuHatyusyo/unsogyomuHatyusyoService"
import dateUtil from "../../../ts/util/dateUtil"
import ComboBox from "../../../components/ComboBox"
import { 部所マスタ } from "../../../service/master/busyo/TBusyo"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import BusyoService from "../../../service/master/busyo/busyoService"
import { setWarningAlerts } from "../../../globalStore/alertStore"
import { T検索日ComboboxItem } from "../ZyutyuHaisyaList/TZyutyuHaisyaList"
import { T検索日種別コード, e検索日種別 } from "../../../constant/enum/frontend"
import {
  T運送業務発注書表示用検索共通,
  T運送業務発注書表示用検索条件,
} from "./UnsogyomuHatyusyoConstant"

//TODO:ダミー用に配置
export type T部所マスタ = 部所マスタ
export type T運送業務発注書印刷GridItem = T運送業務発注書印刷

const 検索日: T検索日ComboboxItem[] = [
  { name: "積日", value: "1" } as const,
  { name: "卸日", value: "2" } as const,
]

/**
 * 運送業務発注書印刷
 * @returns
 */
const UnsogyomuHatyusyo = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )
  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )
  const [accordionController, setAccordionController] = useState(true)

  //TODO:ページ名称確定必須
  let gridId = "UnsogyomuHatyusyo_GridId"

  //検索条件保持用
  const [preSearchCondition, setPreSearchCondition] = useState<
    TUnsogyomuHatyusyoGetReq<T検索日種別コード>
  >({} as TUnsogyomuHatyusyoGetReq<T検索日種別コード>)

  //#region [state]
  // 画面共通
  const [isSearching, setIsSearching] = useState(false)
  const [displaySearchCondition, setDisplaySearchCondition] =
    useState<TUnsogyomuHatyusyoGetReq<T検索日種別コード> | null>()

  const [searchResult, setSearchResult] =
    useState<T運送業務発注書印刷GridItem[]>()

  //検索条件部
  const [検索日コード, set検索日コード] = useState<"1" | "2" | "3" | "">()
  const [, set検索日] = useState<string | null>()
  const [検索日ItemSource, set検索日ItemSource] =
    useState<T検索日ComboboxItem[]>()
  const [検索日From, set検索日From] = useState<string | null | undefined>(
    翌営業日
  )
  const [検索日To, set検索日To] = useState<string | null | undefined>(翌営業日)
  const [傭車会社コード, set傭車会社コード] = useState<string>()
  const [傭車会社名, set傭車会社名] = useState<string>()

  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)

  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)
  const [isInvalid受注部所コード, setIsInvalid受注部所コード] = useState(false)
  //#endregion

  // 検索日
  const [検索日ComboBox, set検索日ComboBox] = useState<TWijmoComboBox<
    T検索日ComboboxItem["value"],
    T検索日ComboboxItem
  > | null>(null)
  const [検索日IsLoadEnded, set検索日IsLoadEnded] = useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)
  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      setComboBoxDataInitialized(true)
      set検索日ItemSource(検索日)
    })
  }, [])
  //#region [effect]
  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 受注部所isLoadEnded && comboBoxDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()
        // リストア中フラグON
        setIsRestoreSearching(true)
        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        set受注部所コード(userInfo.部所コード)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 受注部所isLoadEnded, comboBoxDataInitialized])

  //#endregion

  //#region [method]

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: Partial<
      TUnsogyomuHatyusyoGetReq<"1"> & TUnsogyomuHatyusyoGetReq<"2">
    > = queryString.parse(location.search)
    // 検索日変更用
    if (query.積日From || query.積日To) {
      set検索日コード(e検索日種別.積日)
      set検索日From(query.積日From)
      set検索日To(query.積日To)
    } else if (query.卸日From || query.卸日To) {
      set検索日コード(e検索日種別.卸日)
      set検索日From(query.卸日From)
      set検索日To(query.卸日To)
    }
    set傭車会社コード(query.傭車会社コード)
    set傭車会社名(query.傭車会社名)
    set受注部所コード(query.受注部所コード ?? userInfo.部所コード ?? "")
    return query as TUnsogyomuHatyusyoGetReq<T検索日種別コード>
  }

  /**
   * 検索
   */
  const search = async (
    searchCondition?: TUnsogyomuHatyusyoGetReq<T検索日種別コード>
  ) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition:
      | TUnsogyomuHatyusyoGetReq<T検索日種別コード>
      | null
      | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    // 検索ボタン押下時の検索条件を保持
    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    // TODO:検索処理導入
    try {
      const service = new UnsogyomuHatyusyoService()

      const res = await service.getList(currentSearchCondition)
      setSearchResult([...res.data])
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TUnsogyomuHatyusyoGetReq<T検索日種別コード> | undefined => {
    // return {
    //   検索日From: 検索日From ?? undefined,
    //   検索日To: 検索日To ?? undefined,
    //   傭車会社コード: 傭車会社コード,
    //   傭車会社名: 傭車会社名,
    //   受注部所コード: 受注部所コード ?? "",
    //}

    let 共通検索条件: TUnsogyomuHatyusyoGetReqInner = {
      検索日: 検索日コード ?? undefined,
      検索日From: 検索日From ?? undefined,
      検索日To: 検索日To ?? undefined,
      傭車会社コード: 傭車会社コード,
      傭車会社名: 傭車会社名,
      受注部所コード: 受注部所コード ?? "",
    }
    switch (検索日コード) {
      case e検索日種別.積日:
        let 検索条件1: TUnsogyomuHatyusyoGetReq<"1"> = {
          ...共通検索条件,
          積日From: 検索日From ?? "",
          積日To: 検索日To ?? "",
        }
        return 検索条件1
      case e検索日種別.卸日:
        let 検索条件2: TUnsogyomuHatyusyoGetReq<"2"> = {
          ...共通検索条件,
          卸日From: 検索日From ?? "",
          卸日To: 検索日To ?? "",
        }
        return 検索条件2
      default:
        break
    }
  }

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: TUnsogyomuHatyusyoGetReq<T検索日種別コード>
  ): TUnsogyomuHatyusyoGetReq<T検索日種別コード> | any | undefined => {
    // const 部所Data = 部所ItemSource?.find(
    //   (i) => i.部所コード === searchCondition.受注部所コード
    // )
    // return {
    //   検索日From: dateUtil.format(searchCondition.検索日From) ?? "",
    //   検索日To: dateUtil.format(searchCondition.検索日To) ?? "",
    //   傭車会社コード: searchCondition.傭車会社コード,
    //   傭車会社名: searchCondition.傭車会社名,
    //   受注部所: 部所Data && `${部所Data?.部所コード} ${部所Data?.部所名}`,
    // }
    const 部所Data = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.受注部所コード
    )
    let 表示用検索条件共通部: T運送業務発注書表示用検索共通 = {
      検索日: undefined,
      検索日From: undefined,
      検索日To: undefined,
      傭車会社コード: searchCondition.傭車会社コード,
      傭車会社名: searchCondition.傭車会社名,
      受注部所: 部所Data && `${部所Data?.部所コード} ${部所Data?.部所名}`,
    }
    switch (検索日コード) {
      case e検索日種別.積日: {
        const sc = searchCondition as TUnsogyomuHatyusyoGetReq<"1">
        let 検索条件: T運送業務発注書表示用検索条件<"1"> = {
          積日From: dateUtil.format(sc.積日From) ?? "",
          積日To: dateUtil.format(sc.積日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件
      }
      case e検索日種別.卸日: {
        const sc = searchCondition as TUnsogyomuHatyusyoGetReq<"2">
        let 検索条件: T運送業務発注書表示用検索条件<"2"> = {
          卸日From: dateUtil.format(sc.卸日From) ?? "",
          卸日To: dateUtil.format(sc.卸日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件
      }
      default:
        break
    }
  }

  //#endregion
  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">運送業務発注書印刷</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-100rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <ul className="list-cmn  d-flex">
                          <li>
                            <ul className="list-cmn">
                              <li className="list-cmn d-flex">
                                <div className="w-10rem">
                                  <ComboBox.Default
                                    placeholder="検索日"
                                    itemsSource={検索日ItemSource}
                                    isLoadEnded={検索日IsLoadEnded}
                                    selectedValue={検索日コード}
                                    isRequired={true}
                                    setSelectedValue={(v) => {
                                      set検索日コード(v)
                                    }}
                                    setText={set検索日}
                                    setIsLoadEnded={set検索日IsLoadEnded}
                                    ComboBox={検索日ComboBox}
                                    setComboBox={
                                      set検索日ComboBox
                                    }></ComboBox.Default>
                                </div>
                                <div
                                  style={{
                                    width: "2rem",
                                    padding: "0.5rem",
                                  }}></div>
                                <div className="w-9rem">
                                  <DateInput
                                    id="検索日From"
                                    placeholder="検索日From"
                                    isRequired={true}
                                    value={検索日From}
                                    defaultValue={翌営業日}
                                    setValue={(v) => {
                                      set検索日From(v)
                                    }}></DateInput>
                                </div>
                                <div
                                  style={{ width: "2rem", padding: "0.5rem" }}>
                                  ～
                                </div>
                                <div className="w-9rem">
                                  <DateInput
                                    id="検索日To"
                                    placeholder="検索日To"
                                    value={検索日To}
                                    isRequired={true}
                                    defaultValue={翌営業日}
                                    setValue={(v) => {
                                      set検索日To(v)
                                    }}></DateInput>
                                </div>
                                <div style={{ width: "2rem" }}></div>
                                <div className="d-flex">
                                  <TextInput
                                    style={{ width: "7rem" }}
                                    id="傭車会社コード"
                                    name="傭車会社コード"
                                    value={傭車会社コード}
                                    setValue={(v) => {
                                      set傭車会社コード(v)
                                    }}
                                    maxLength={10}
                                    placeholder="傭車先CD"
                                  />
                                  <TextInput
                                    style={{ width: "25rem" }}
                                    id="傭車会社名"
                                    name="傭車会社名"
                                    value={傭車会社名}
                                    setValue={set傭車会社名}
                                    maxLength={100}
                                    placeholder="傭車会社名"
                                  />
                                </div>
                                <div style={{ width: "2rem" }}></div>
                                <div className=""></div>
                                <ComboBox.Busyo
                                  placeholder="受注部所"
                                  isLoadEnded={受注部所isLoadEnded}
                                  setIsLoadEnded={set受注部所isLoadEnded}
                                  className={
                                    isInvalid受注部所コード
                                      ? "busyo-combo-box is-error"
                                      : "busyo-combo-box"
                                  }
                                  isAllSelect={false}
                                  isEmpty={false}
                                  isRequired={true}
                                  itemsSource={部所ItemSource}
                                  selectedValue={受注部所コード}
                                  listFilter={(d) => d.運行部所フラグ === 1}
                                  setSelectedValue={(v) => {
                                    set受注部所コード(v)
                                  }}
                                  ComboBox={受注部所ComboBox}
                                  setComboBox={
                                    set受注部所ComboBox
                                  }></ComboBox.Busyo>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            // 受注部所、未選択の場合検索させない
                            if (
                              受注部所コード == null ||
                              受注部所コード === ""
                            ) {
                              setIsInvalid受注部所コード(true)
                              dispatch(
                                setWarningAlerts(["受注部所を選択してください"])
                              )
                              return
                            } else {
                              setIsInvalid受注部所コード(false)
                            }
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col xs={12}>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <UnsogyomuHatyusyoProvider
                isSearching={{ state: isSearching, setState: setIsSearching }}
                isRestoreSearching={{
                  state: isRestoreSearching,
                  setState: setIsRestoreSearching,
                }}
                SearchResult={searchResult}
                gridInitialized={{
                  state: gridInitialized,
                  setState: setGridInitialized,
                }}>
                <UnsogyomuHatyusyoGrid
                  gridId={gridId}
                  kensakubiCd={検索日コード}
                  kensakubiFrom={preSearchCondition.検索日From}
                  kensakubiTo={preSearchCondition.検索日To}
                  yosyaCd={preSearchCondition.傭車会社コード}
                  yosyaNm={preSearchCondition.傭車会社名}
                  zyutyuBusyoCd={
                    preSearchCondition.受注部所コード
                  }></UnsogyomuHatyusyoGrid>
              </UnsogyomuHatyusyoProvider>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default UnsogyomuHatyusyo
